import styled from 'styled-components';
import {
  List, TextField, Tooltip, Alert,
} from '@mui/material';
import { withStyles } from '@mui/styles';

import { Styling, Colors } from '../../../../constants';

const teamSize = 24;
const labelWidth = 70;
const labelRightMargin = Styling.DEFAULT_SPACING;
const valueRowHeight = 48;

const contentSpacing = `0 ${Styling.DEFAULT_SPACING_DOUBLED + 2}px 0 ${labelWidth + labelRightMargin + Styling.DEFAULT_SPACING_DOUBLED}px`;

const successColor = '#3A825C';

interface IFeedbackContainerProps {
  'data-error': boolean;
}
interface IFormGroupProps {
  disabled?: boolean;
}

export const StyledTooltip = withStyles(() => ({
  tooltip: {
    fontSize: 13,
  },
}))(Tooltip);

export const styledTooltip = styled(Tooltip)`
  font-size: 20px;
`;

export const InputHeader = styled.h2`
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 5px;
`;

export const ContactsContentContainer = styled.div`
  padding: 0 50px;
`;

export const ContactList = styled(List)`
  margin-top: 46px !important;
  max-height: calc(100vh - 285px);
  overflow: overlay;
`;

export const TeamContactList = styled(List)`
  max-height: calc(100vh - 320px);
  overflow: overlay;
`;

export const ListItemHeader = styled(List)`
  .MuiAvatar-root {
    width: 70px;
    height: 70px;
    margin-right: ${Styling.DEFAULT_SPACING}px;
    font-size: 1.8rem;
  }

  .MuiListItemText-root {
    span {
      font-size: 1.8rem;
    }
    p {
      font-size: 1.2rem;
    }
  }
`;

export const PersonContainer = styled.div`
  display: flex;
`;

export const PersonContent = styled.div`
  flex-grow: 1;
`;

export const PersonAvatar = styled.div`
  .MuiAvatar-root {
    width: 56px;
    height: 56px;
    margin-right: ${Styling.DEFAULT_SPACING}px;
    font-size: 1.8rem;
    margin-top: 25px;
  }
`;

export const ProgressContainer = styled.div`
  height: ${Styling.DEFAULT_LINEAR_PROGRESS_HEIGHT}px;
`;

const InfoContainer = styled(Alert).attrs({
  severity: 'info' as const,
})`
  margin: ${Styling.DEFAULT_SPACING}px auto ${Styling.DEFAULT_SPACING_HALVED}px auto;
  padding: ${contentSpacing};
  padding: ${Styling.DEFAULT_SPACING}px;
  justify-content: center;
  width: 500px;
`;

export {
  InfoContainer,
};

export const StyledTextField = styled(TextField)`
  input {
    padding: ${Styling.DEFAULT_SPACING}px !important;
  }
`;

export const Form = styled.div`
  min-height: 400px;
`;

export const Label = styled.h1`
  cursor: default;
  text-align: left;
  font-weight: bolder;
  margin-bottom: 5px;
`;

export const FormGroup = styled.div<IFormGroupProps>`
  padding: ${Styling.DEFAULT_SPACING}px;
  ${(props) => (props.disabled ? `
    ${Label} {
      color: ${Colors.LIGHT_GREY};
    }
  ` : null)}
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CancelSaveContainer = styled.div`
  display: flex;
  .MuiButtonBase-root {
    margin-right: 10px;
  }
`;

export const FeedbackContainer = styled.div<IFeedbackContainerProps>`
  border: solid ${successColor};
  border-width: 2px 2px 2px 6px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  height: 60px;

  .MuiSvgIcon-root {
    margin-left: 13px;
    margin-right: 11px;
    color: ${successColor};
  }

  span {
    font-weight: 700;
  }

  ${(props) => (props['data-error'] ? `
    border: solid ${Colors.ERROR};
    border-width: 2px 2px 2px 6px;
    .MuiSvgIcon-root {
      color: ${Colors.ERROR};
    }
  ` : null)}
`;
